import { render, staticRenderFns } from "./SubApplications.vue?vue&type=template&id=1cd8c2c5&scoped=true&"
import script from "./SubApplications.vue?vue&type=script&lang=js&"
export * from "./SubApplications.vue?vue&type=script&lang=js&"
import style0 from "./SubApplications.vue?vue&type=style&index=0&id=1cd8c2c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd8c2c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCardText,VDivider,VExpandTransition,VIcon,VList,VListItemGroup,VToolbar})
